export default __webpack_public_path__ + "static/media/redeem.5d814b1f.svg";